import React, { Component } from "react";
import { Card, CardBody, Wrapper } from "app/NativeComponents/common";

import { Select, ToggleSwitch } from "app/NativeComponents/snippets";

import MapViewButton from "./MapViewButton";
import Legend from "./Legend";
import PropertyLabel from "./PropertyLabel";

import OnboardingContainer from "app/DealMachineCore/snippets/OnboardingContainer";

import { checkIfUserHasBillingAddon } from "app/NativeActions";

class Body extends Component {
  constructor(props) {
    super(props);
    let label_options_array = [];

    label_options_array.push({
      key: 0,
      value: "Male (United States)",
      label: "Male (United States)"
    });
    label_options_array.push({
      key: 1,
      value: "Female (United States)",
      label: "Female (United States)"
    });
    label_options_array.push({
      key: 2,
      value: "Male (Great Britain)",
      label: "Male (Great Britain)"
    });
    label_options_array.push({
      key: 3,
      value: "Female (Great Britain)",
      label: "Female (Great Britain)"
    });
    label_options_array.push({
      key: 4,
      value: "Male (Australian)",
      label: "Male (Australian)"
    });
    label_options_array.push({
      key: 5,
      value: "Female (Australian)",
      label: "Female (Australian)"
    });
    label_options_array.push({
      key: 6,
      value: "Male (Indian)",
      label: "Male (Indian)"
    });
    label_options_array.push({
      key: 7,
      value: "Female (Indian)",
      label: "Female (Indian)"
    });
    this.state = {
      label_options_array: label_options_array,
      nav_voice: this.props.user.user_settings.navigation_voice
        ? this.props.user.user_settings.navigation_voice
        : "Male (United States)"
    };
  }

  componentDidMount() {
    this.setState({
      nav_voice: this.props.user.user_settings.navigation_voice
        ? this.props.user.user_settings.navigation_voice
        : "Male (United States)"
    });
  }

  renderPerformanceModeSwitch() {
    if (this.props.device === "mobile") {
      return (
        <Card>
          <ToggleSwitch
            onChange={value => {
              this.props.editPropertyMapOptions({
                prop: "performance_mode",
                value
              });
            }}
            value={this.props.property_map_options.performance_mode}
            title={"Use Performance Mode"}
            text={
              'If you\'re having lagging issues, try "Performance Mode". This will hide markers while panning the map and will only show your added properties. If problems continue, please contact support.'
            }
          />
        </Card>
      );
    }
  }

  renderNavVoice() {
    if (this.props.device === "mobile") {
      return (
        <Card>
          <Select
            item_ref={"select_nav_voice"}
            items={this.state.label_options_array}
            title="Navigation Voice:"
            label="Select an option"
            value={this.state.nav_voice}
            text={this.state.nav_voice}
            onSelect={value => {
              this.setState({ nav_voice: value });
              this.props.updateUserSettings({
                token: this.props.token,
                type: "navigation_voice",
                value: value,
                show_loading: true
              });
            }}
          />
        </Card>
      );
    }
  }

  renderRouteSwitch() {
    //need the driving module with tier 2 to access

    if (this.props.plan_module_info) {
      if (
        ((!this.props.plan_module_info.has_module ||
          (this.props.plan_module_info.has_module &&
            this.props.plan_module_info.tier < 2)) &&
          !checkIfUserHasBillingAddon({
            billing_addons: this.props.billing_addons,
            slug: "routes"
          }) &&
          this.props.user.team_clearance_level > 0) ||
        this.props.card_info.bad_card == 1
      ) {
        return (
          <OnboardingContainer
            plan_module_info={this.props.plan_module_info}
            slug="driving"
            contentful_slug="drivingRoutes"
            require_tier={2}
            isCard={true}
          />
        );
      }
      if (
        this.props.plan_module_info.tier >= 2 ||
        checkIfUserHasBillingAddon({
          billing_addons: this.props.billing_addons,
          slug: "routes"
        })
      ) {
        return (
          <Card>
            <ToggleSwitch
              onChange={value => {
                this.props.toggleShowRoutes(value);
                this.props.updateUserSettings({
                  token: this.props.token,
                  type: "show_routes",
                  value: value
                });
              }}
              value={this.props.show_routes == true ? true : false}
              title={"Show Driving Routes?"}
              text={"Shows past driving routes on the map."}
            />
            <Legend {...this.props} />
          </Card>
        );
      }
    }

    return <Wrapper />;
  }

  render() {
    return (
      <Wrapper style={{ paddingBottom: 60 }}>
        <CardBody>
          <MapViewButton {...this.props} />
        </CardBody>

        {this.renderRouteSwitch()}
        <Card>
          <PropertyLabel {...this.props} />
        </Card>
        {this.renderNavVoice()}
        {/*
        <Card>
          <PropertyHighlight {...this.props}/>
        </Card>
        */}

        {this.renderPerformanceModeSwitch()}
      </Wrapper>
    );
  }
}

export default Body;
